<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12 mb-3">
        <BaseCard :data="data" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCard from "@/components/ui/BaseCard.vue";

export default {
  name: "Home",
  components: {
    BaseCard,
  },
  data() {
    return {
      data: {
        header: "Ability to Pay for Personal or Household Expenses",
        content:
          "Provides the percent of survey respondents that have had difficulty paying for different expenses ranging from food, rent to internet for each state and region in Nigeria.",
        location: "Nigeria",
        period: "2019",
        link: "#",
      },
    };
  },
  methods: {},
};
</script>
